import React from "react";
import styles from "../../components.module.css";
import { DynamicForm } from "../../index";
import FieldHeader from "../FieldHeader";

function Nested({ parameters, value = {}, onChange, utilsData }) {
  const children = Object.keys(parameters.children);

  const handleChange = function (newValue) {
    onChange({
      ...value,
      ...newValue,
    });
  };

  return (
    <div>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      {children.map((child, index) => {
        return (
          <div key={index}>
            {parameters.label && parameters.label.length && (
              <div className={styles.form_control_label}>
                <span>{parameters.label || ""}</span>
              </div>
            )}
            <div style={{ marginLeft: ".5rem" }}>
              <DynamicForm
                parametersModel={{
                  [child]: parameters.children[child],
                }}
                formData={value}
                onParameterChange={(newValue) => handleChange(newValue)}
                utilsData={utilsData}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Nested;
